import './ChatSupport.scss';
export const setupChat = function(){
  window.amiraChatbotConfig = {
    ProductLine: "Amira",
  };
  const chatbotUrl = process.env.AMIRABOT_URL as string;
  const script = document.createElement("script");
  script.type = "module";
  script.src = chatbotUrl;
  script.async = true;
  script.defer = true;
  script.id = "amira-chatbot-script";
  document.body.appendChild(script);
};

export default setupChat;